import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/public/Header";
import Footer from "@/components/public/Footer";

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen bg-ink-950 relative">
      <Header />
      <main className="relative z-[2]">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
